import React from "react";

const VolumeIcon = (props: any) => {
  return (
    <svg width={20} height={21} fill="none" {...props}>
      <path
        fill="var(--color-icon-bright)"
        stroke="var(--color-icon-bright)"
        d="m8.618 16.546-.002-.002-2.433-1.524-.009-.006a1.579 1.579 0 0 0-.807-.23h-1.2c-.92 0-1.557-.25-1.965-.659-.409-.409-.66-1.046-.66-1.965V8.826c0-.919.251-1.556.66-1.965.408-.408 1.046-.66 1.965-.66h1.192c.291 0 .571-.088.807-.23v.001l.008-.005 2.432-1.525h.001c1.126-.701 2.108-.767 2.826-.37.719.398 1.184 1.262 1.184 2.596v7.642c0 1.324-.473 2.199-1.186 2.597l-.01.006a1.87 1.87 0 0 1-.962.247c-.542 0-1.176-.194-1.841-.614Zm-2.311-1.731.003.002 2.433 1.525c.85.53 1.823.783 2.576.363.75-.418 1.056-1.367 1.056-2.37V6.676c0-1.006-.304-1.96-1.059-2.371-.75-.416-1.72-.177-2.573.365l-2.44 1.515-.009.006a1.72 1.72 0 0 1-.935.269H4.167c-.715 0-1.344.15-1.785.59-.44.44-.59 1.07-.59 1.785v3.333c0 .715.15 1.344.59 1.785.44.44 1.07.59 1.785.59h1.192c.341 0 .664.092.948.272ZM15.5 14.21l-.4-.3a.122.122 0 0 1-.044.038.13.13 0 0 1-.134-.016.125.125 0 0 1-.023-.17l.001-.002a5.45 5.45 0 0 0 0-6.517l-.001-.002a.125.125 0 0 1 .203-.146l.398-.302m0 7.417-.4-.3a5.726 5.726 0 0 0 0-6.817l.4-.3m0 7.417a6.225 6.225 0 0 0 0-7.417m0 7.417a.616.616 0 0 1-.5.25.634.634 0 0 1-.375-.125L14.5 7.543a.625.625 0 0 1 1-.75"
      />
      <path
        fill="var(--color-icon-bright)"
        d="M16.525 16.54a.625.625 0 0 1-.5-1c2.225-2.966 2.225-7.116 0-10.083a.625.625 0 0 1 1-.75c2.558 3.409 2.558 8.175 0 11.584a.604.604 0 0 1-.5.25Z"
      />
    </svg>
  );
};

export default VolumeIcon;
